module.exports = __webpack_public_path__ + "img/3.17f4c1d7.png";